import { PHOTO_TITLE } from "../constants"

class TitleElement {
  constructor(element) {
    this.element = element
    // Store location, author, and initial photo title from data attributes
    this.locationName = element?.dataset.locationName || ""
    this.authorName = element?.dataset.authorName || ""
    this.initialPhotoTitle = element?.dataset.photoTitle || ""
  }

  static fromHtmlElement(htmlElement) {
    const element = htmlElement.querySelector(PHOTO_TITLE)
    return element ? new TitleElement(element) : null
  }

  apply(photo) {
    if (!this.element) return

    // Use the photo title from API, or fall back to initial photo title from data attribute
    // The API returns just the photo name, not the full formatted string
    const photoTitle = photo.title || this.initialPhotoTitle || ""
    const locationName = this.locationName || ""
    const authorName = photo.author?.name || this.authorName || ""

    // Reconstruct the title with proper translation format
    // Match the same logic as the server-side template
    let titleText = ""
    if (photoTitle && authorName) {
      titleText = `${locationName} Surf Photo: '${photoTitle}' by ${authorName}`
    } else if (photoTitle) {
      titleText = `${locationName} Surf Photo: '${photoTitle}'`
    } else if (authorName) {
      titleText = `${locationName} Surf Photo by ${authorName}`
    } else {
      titleText = `${locationName} Surf Photo`
    }

    this.element.textContent = titleText
  }
}

export default TitleElement
